// RunPage — French. The console's language; the record's own content is French too, but the two
// are separate things. 'not collected', 'Loading…', 'Saving…', 'refused', 'held', 'unheld' and
// the small words live in common.fr.ts.
//
// 'running' and the '{unheld} … {held} … {refused}' tally are deliberately ABSENT: another
// catalogue already declares each of them and the first registration wins, so a second spelling
// could only add noise to the console. The step kinds ARE declared, because
// they are this page's own closed vocabulary (BUILD-BRIEF-R3f §1).
import { registerFr } from '../i18n/index.js';

registerFr({
  'Run': 'Passe',
  'Agents': 'Agents',
  'no run was addressed': 'aucune passe n’a été adressée',
  'This address names no run': 'Cette adresse ne désigne aucune passe',
  'A run desk is opened as #run?id=N from a RUN- ref — on the Agents panel, on an organisation’s brief, or beside a proposal in Review.':
    'Un poste de passe s’ouvre en #run?id=N depuis une référence RUN- — sur la page Agents, sur la fiche d’une organisation, ou à côté d’une proposition en revue.',
  'reading the run…': 'lecture de la passe…',
  'the runtime did not answer': 'le moteur d’exécution n’a pas répondu',
  'Could not read this run': 'Impossible de lire cette passe',

  // ── the masthead ──
  'started': 'démarrée',
  'queued': 'en file',
  'ended': 'terminée',
  'Open in Review': 'Ouvrir en revue',
  'Abort': 'Interrompre',

  // ── the rail ──
  'Status': 'Statut',
  'failed‖run': 'échouée',
  'done': 'terminé',
  'aborted': 'interrompue',
  'behind {n}': '{n} devant',
  '{live} of {cap} running': '{live} sur {cap} en cours',
  'night cap': 'plafond de nuit',
  'weekend cap': 'plafond du week-end',
  'the gate has not reported a position': 'la barrière n’a annoncé aucun rang',
  'started {when}': 'démarrée {when}',
  'not started yet': 'pas encore démarrée',
  'Tokens': 'Tokens',
  'in / out': 'entrée / sortie',
  'nothing has been spent yet': 'rien n’a encore été dépensé',
  'the run reported no token count': 'la passe n’a annoncé aucun compte de tokens',
  '{n} failed': '{n} en échec',
  'the total arrives when the run ends · the steps count as they go': 'le total arrive à la fin de la passe · les étapes comptent au fil de l’eau',
  'Tool calls': 'Appels d’outils',
  '{n} refused': '{n} refusés',
  'it has called nothing': 'elle n’a rien appelé',
  'every call was answered': 'chaque appel a reçu une réponse',
  'Proposals filed': 'Propositions déposées',
  'it has proposed nothing': 'elle n’a rien proposé',
  'Cells': 'Cellules',
  'this skill fills no raster cell': 'cette compétence ne remplit aucune cellule de la grille',
  'raster cells filed as proposals · held in Review': 'cellules de la grille déposées en propositions · retenues en Revue',
  'it filed no cell': 'elle n’a déposé aucune cellule',
  'cells arrive as it reads': 'les cellules arrivent à mesure qu’elle lit',

  // ── the steps zone ──
  'Steps': 'Étapes',
  'appended live · every three seconds': 'ajoutées en direct · toutes les trois secondes',
  '{n} of {total} recorded': '{n} sur {total} enregistrées',
  'the account this run left of itself': 'le compte rendu que cette passe a laissé d’elle-même',
  'Follow': 'Suivre',
  'Keep the newest step in view as it arrives': 'Garder la dernière étape en vue dès son arrivée',
  'The steps did not load: {error}': 'Les étapes n’ont pas pu être chargées : {error}',
  'This server has recorded no steps for this run — the steps route did not answer. What the run called is still below in the ledger, and what it filed is still in Review.':
    'Ce serveur n’a enregistré aucune étape pour cette passe — la route des étapes n’a pas répondu. Ce que la passe a appelé figure toujours dans le journal ci-dessous, et ce qu’elle a déposé figure toujours en revue.',
  'No step yet. The loop writes one as it queues, starts, plans, reads a page, calls the model and proposes or drops a cell; they arrive here without a reload.':
    'Aucune étape pour l’instant. La boucle en écrit une à la mise en file, au démarrage, au plan, à chaque page lue, à chaque appel du modèle et à chaque cellule proposée ou écartée ; elles arrivent ici sans rechargement.',
  'This run recorded no step. It ran before the steps table existed, or it ended before it wrote one.':
    'Cette passe n’a enregistré aucune étape. Elle s’est déroulée avant l’existence de la table des étapes, ou s’est terminée avant d’en écrire une.',
  'detail': 'détail',
  'What this step recorded, as it recorded it': 'Ce que cette étape a enregistré, tel qu’elle l’a enregistré',

  // the closed set of step kinds — this page's own vocabulary, declared in full
  'plan': 'plan',
  'hide': 'masquer',
  'search': 'recherche',
  'fetch': 'récupération',
  'read': 'lecture',
  'model': 'modèle',
  'propose': 'proposition',
  'drop': 'écartée',
  'waiting': 'en attente',
  'finish': 'fin',
  'truncated': 'tronquée',

  // ── the proposals, the ledger, the report ──
  'Proposals': 'Propositions',
  'nothing is on the record until an operator holds it':
    'rien n’est au dossier tant qu’un opérateur ne l’a pas retenu',
  'Review': 'Revue',
  'This run has filed nothing. A run proposes: a fact with its quote, a person with the line that names them, a draft. Each one waits in Review for a click.':
    'Cette passe n’a rien déposé. Une passe propose : un fait avec sa citation, une personne avec la ligne qui la nomme, un brouillon. Chacun attend un clic en revue.',
  'Ledger': 'Journal',
  'every call this run made · refusals included': 'chaque appel de cette passe · refus compris',
  'This run called no tool. Only an agent that goes through the registry writes ledger rows.':
    'Cette passe n’a appelé aucun outil. Seul un agent qui passe par le registre écrit des lignes de journal.',
  'no input recorded': 'aucune entrée enregistrée',
  'answered': 'répondu',
  'error': 'erreur',
  'Report': 'Rapport',
  'the agent’s final answer, as it wrote it': 'la réponse finale de l’agent, telle qu’il l’a écrite',
  'the agent writes one when it ends': 'l’agent en écrit un à sa fin',
  'The child’s own output, while it runs. Not a report, and not a claim.':
    'La sortie du processus enfant, pendant qu’il tourne. Ni un rapport, ni une affirmation.',
  'No report yet. The agent answers when it has finished; its steps above say what it is doing meanwhile.':
    'Pas encore de rapport. L’agent répond quand il a terminé ; ses étapes ci-dessus disent ce qu’il fait entre-temps.',
  'This run left no report. It ended before the agent answered; its steps and its ledger are the account.':
    'Cette passe n’a laissé aucun rapport. Elle s’est terminée avant que l’agent réponde ; ses étapes et son journal en sont le compte rendu.',

  // ── the modal ──
  'Stop {ref}?': 'Arrêter {ref} ?',
  '{ref} was asked to stop. It stops at its next step boundary.':
    'Il a été demandé à {ref} de s’arrêter. Elle s’arrête à sa prochaine limite d’étape.',
  'Could not stop this run.': 'Impossible d’arrêter cette passe.',
  'It stops at its next step boundary. Everything it has already filed stays in Review, and everything it has already spent stays on the record — a stopped run is a shorter run, not an undone one.':
    'Elle s’arrête à sa prochaine limite d’étape. Tout ce qu’elle a déjà déposé reste en revue, et tout ce qu’elle a déjà dépensé reste au dossier — une passe arrêtée est une passe plus courte, pas une passe annulée.',
  'signal_action': 'action sur signal',
  'rule_change': 'changement de règle',
}, 'RunPage');
